
const digest = 'c4b5cc3edbaa5d3a676185c98d3d4cde4dd64e185564ac888866e80dcf89e02f';
const classes = {"wrapper":"_wrapper_q9u3d_1","header":"_header_q9u3d_6","items":"_items_q9u3d_10","inline":"_inline_q9u3d_16","item":"_item_q9u3d_10","title":"_title_q9u3d_27","bold":"_bold_q9u3d_31","between":"_between_q9u3d_35","optionalSchedule":"_optionalSchedule_q9u3d_42","eventInputs":"_eventInputs_q9u3d_47","timesRow":"_timesRow_q9u3d_54","timeField":"_timeField_q9u3d_60"};
const css = `._wrapper_q9u3d_1 {
  display: flex;
  flex-direction: column;
  gap: 40px;
}
._wrapper_q9u3d_1 ._header_q9u3d_6 {
  display: flex;
  justify-content: flex-end;
}
._wrapper_q9u3d_1 ._items_q9u3d_10 {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: fit-content;
}
._wrapper_q9u3d_1 ._inline_q9u3d_16 {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
}
._wrapper_q9u3d_1 ._item_q9u3d_10 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}
._wrapper_q9u3d_1 ._title_q9u3d_27 {
  font-size: 12px;
  color: #6f6f6f;
}
._wrapper_q9u3d_1 ._bold_q9u3d_31 {
  font-size: 14px;
  font-weight: 600;
}
._wrapper_q9u3d_1 ._between_q9u3d_35 {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 20px;
  align-items: flex-start;
}
._wrapper_q9u3d_1 ._optionalSchedule_q9u3d_42 {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
._wrapper_q9u3d_1 ._eventInputs_q9u3d_47 {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  padding-inline-start: 4px;
}
._wrapper_q9u3d_1 ._timesRow_q9u3d_54 {
  display: flex;
  flex-direction: row;
  gap: 20px;
  flex-wrap: wrap;
}
._wrapper_q9u3d_1 ._timeField_q9u3d_60 {
  min-width: 140px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  